'use client';
import React from 'react';

function GlassFacade() {
  return (
    <section className="tc-service-details py-5">
      <div className="container">
        {/* Header */}
        <div className="page-hero">
  <div className="img position-relative">
    <img
      src="\home2\assets\img\services\glassfacade.jpg"
      alt="Facade Solutions"
      className="img-fluid w-100 radius-6"
    />

    {/* Desktop Overlay */}
    <div className="info-overlay desktop-only d-flex align-items-end">
      <div className="container pb-40">
        <h1
          className="text-white fw-600 fsz-50 wow fadeInUp slow"
          data-wow-delay="0.2s"
        >
          Glass Facade
        </h1>
        <p
          className="text-white-50 mt-10 fsz-18 wow fadeInUp slow"
          data-wow-delay="0.3s"
        >
          Transforming buildings with sleek, energy-efficient glass facade designs.
        </p>
      </div>
    </div>
  </div>

  {/* Mobile Text (below image) */}
  <div className="info-under mobile-only">
    <div className="container pt-3 pb-3">
      <h1 className="text-dark fw-600 fsz-28">Glass Facade</h1>
      <p className="text-dark mt-2 fsz-15">
        Transforming buildings with sleek, energy-efficient glass facade designs.
      </p>
    </div>
  </div>
</div>


        {/* Service Sections */}
        <div className="solution-item mt-80 mb-80">
          <h4 className="fsz-30 fw-600 mb-30 wow fadeInUp slow" data-wow-delay="0.2s">
            1. Curtain Wall Glazing
          </h4>
          <ul className="dots-list fsz-18 color-666 wow fadeInUp slow" data-wow-delay="0.2s">
            <li className="d-flex my-3">
              <span className="icon me-3">•</span> Lightweight, non-structural exterior wall system.
            </li>
            <li className="d-flex my-3">
              <span className="icon me-3">•</span> Offers maximum natural light while maintaining insulation and weather protection.
            </li>
            <li className="d-flex my-3">
              <span className="icon me-3">•</span> Customizable designs to match modern architectural aesthetics.
            </li>
          </ul>
        </div>

        <div className="solution-item mb-80">
          <h4 className="fsz-30 fw-600 mb-30 wow fadeInUp slow" data-wow-delay="0.3s">
            2. Stick Glazing
          </h4>
          <ul className="dots-list fsz-18 color-666 wow fadeInUp slow" data-wow-delay="0.3s">
            <li className="d-flex my-3">
              <span className="icon me-3">•</span> On-site installation allows flexibility for complex geometries.
            </li>
            <li className="d-flex my-3">
              <span className="icon me-3">•</span> Cost-effective for smaller to medium-sized facades.
            </li>
            <li className="d-flex my-3">
              <span className="icon me-3">•</span> Ensures easy replacement and maintenance of individual panels.
            </li>
          </ul>
        </div>

        <div className="solution-item mb-80">
          <h4 className="fsz-30 fw-600 mb-30 wow fadeInUp slow" data-wow-delay="0.4s">
            3. Window Wall System
          </h4>
          <ul className="dots-list fsz-18 color-666 wow fadeInUp slow" data-wow-delay="0.4s">
            <li className="d-flex my-3">
              <span className="icon me-3">•</span> Designed for fast installation and modular assembly.
            </li>
            <li className="d-flex my-3">
              <span className="icon me-3">•</span> Ideal for mid-rise buildings requiring efficient enclosure systems.
            </li>
            <li className="d-flex my-3">
              <span className="icon me-3">•</span> Provides uniform appearance and structural reliability.
            </li>
          </ul>
        </div>

        <div className="solution-item mb-80">
          <h4 className="fsz-30 fw-600 mb-30 wow fadeInUp slow" data-wow-delay="0.5s">
            4. Slim Profile System
          </h4>
          <ul className="dots-list fsz-18 color-666 wow fadeInUp slow" data-wow-delay="0.5s">
            <li className="d-flex my-3">
              <span className="icon me-3">•</span> Minimal framing with maximum glass visibility.
            </li>
            <li className="d-flex my-3">
              <span className="icon me-3">•</span> Enhances natural light flow and modern aesthetic.
            </li>
            <li className="d-flex my-3">
              <span className="icon me-3">•</span> Ideal for high-end commercial and residential spaces.
            </li>
          </ul>
        </div>

        {/* CTA */}
        {/* <div className="text-center mt-80">
          <h4 className="fsz-24 fw-semibold mb-3">
            Build with transparency, innovation, and architectural excellence.
          </h4>
          <a href="/contact" className="butn butn-md bg-orange1 text-white rounded-pill px-4 py-2 fw-semibold">
            Contact Us Today
          </a>
        </div> */}
      </div>
    </section>
  );
}

export default GlassFacade;
